import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import { ContactFragmentDoc } from '../../fragments/__generated__/contact';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ContactsUpdateMutationVariables = Types.Exact<{
  contact: Types.PartnersInputsContactType;
}>;


export type ContactsUpdateMutation = { __typename?: 'Mutation', contactsUpdate?: { __typename?: 'ContactsUpdatePayload', contact: { __typename?: 'Contact', id: number, firstName: string, lastName: string, locale?: Types.ProvidersContactsLocaleEnumType | null, email: string, position?: string | null, phone?: string | null, telegram?: string | null, viber?: string | null, whatsapp?: string | null, wechat?: string | null, preferredContactType?: string | null } } | null };


export const ContactsUpdateDocument = gql`
    mutation contactsUpdate($contact: PartnersInputsContactType!) {
  contactsUpdate(input: {contact: $contact}) {
    contact {
      ...contact
    }
  }
}
    ${ContactFragmentDoc}`;
export type ContactsUpdateMutationFn = Apollo.MutationFunction<ContactsUpdateMutation, ContactsUpdateMutationVariables>;

/**
 * __useContactsUpdateMutation__
 *
 * To run a mutation, you first call `useContactsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactsUpdateMutation, { data, loading, error }] = useContactsUpdateMutation({
 *   variables: {
 *      contact: // value for 'contact'
 *   },
 * });
 */
export function useContactsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ContactsUpdateMutation, ContactsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactsUpdateMutation, ContactsUpdateMutationVariables>(ContactsUpdateDocument, options);
      }
export type ContactsUpdateMutationHookResult = ReturnType<typeof useContactsUpdateMutation>;
export type ContactsUpdateMutationResult = Apollo.MutationResult<ContactsUpdateMutation>;
export type ContactsUpdateMutationOptions = Apollo.BaseMutationOptions<ContactsUpdateMutation, ContactsUpdateMutationVariables>;